@if (notifications().length > 0) {
	<div class="enrollment-notifications" aria-label="Enrollment notifications">
		@for (notification of notifications(); track notification.id) {
			<md-content-box [type]="notification.type" class="enrollment-notifications__item">
				<!-- <div class="enrollment-notifications__content"> -->
				<h4 class="enrollment-notifications__title">
					@if (notification.icon) {
						<md-icon [icon]="notification.icon"></md-icon>
					}
					{{ notification.title }}
				</h4>
				<div class="enrollment-notifications__message">{{ notification.message }}</div>
				@if (notification.actionLabel && notification.action) {
					<button type="button" md-button (click)="notification.action()">
						{{ notification.actionLabel }}
					</button>
				}
			</md-content-box>
		}
	</div>
}
